import {v4 as uuidv4} from 'uuid';

export function randomUUID() {
    return uuidv4();
}